<template>
    <div class="roleMsg">
            <el-alert title="温馨提示：编辑角色，拥有该角色包含权限的账号会同步更改，请谨慎编辑！" type="warning" show-icon></el-alert>
            <div class="form">
                <el-form :model="roleMsg" :rules="roleRules" ref="roleMsg" label-width="100px" class="demo-ruleForm">
                    <div class="basicBox">
                        <div class="basicTitle">
                            <span class="erect">|</span>
                            基本信息
                        </div>
                        <el-form-item label="角色名称" prop="rolename">
                            <el-input v-if="judgeAction != '查看'" v-model.trim="roleMsg.rolename" placeholder="请输入角色名称" clearable></el-input>
                            <span v-else>高级管理员</span>
                        </el-form-item>
                        <el-form-item label="角色描述" prop="memo">
                            <el-input v-if="judgeAction != '查看'" type="textarea" v-model.trim="roleMsg.memo" placeholder="请输入描述" clearable></el-input>
                            <span v-else>具有店铺所有管理权限</span>
                        </el-form-item>
                    </div>
                    <div class="rootBox">
                        <div class="rootTitle">
                            <span class="erect">|</span>
                            权限设置
                        </div>
                        <div class="rootTreeBox">
                            <powerTree ref="powerTree" :isDisabled="false"></powerTree>
                        </div>
                    </div>
                    <el-form-item class="action">
                        <el-button @click="resetForm('roleMsg')">取消</el-button>
                        <el-button type="primary" @click="submitForm('roleMsg')">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
</template>
<script>
import {addRole, getRoleinfo} from '@/api/subAccountApi'
import {mapGetters, mapActions} from 'vuex'
import PowerTree from 'base/tree/powerTree'
export default {
    name: 'roleMsg',
    data() {
        // 检查角色名
        let checkRoleName = (rule, value, callback) => {
            let checkTrimRegular = /(^\s*)|(\s*$)/g
            if (!value.replace(checkTrimRegular, '')) {
                callback(new Error('请输入角色名称'))
            } else {
                callback()
            }
        }
        return {
            roleMsg: {
                innerid: this.$route.query.id ? this.$route.query.id : '',
                rolename: '',
                memo: '',
                authidlist: {}
            },
            roleRules: {
                rolename: [
                    {required: true, message: '请输入角色名称', trigger: 'blur'},
                    {validator: checkRoleName, trigger: 'blur'}
                ]
            },
            checkedRootData: [], // 选择的权限数据
            checkedKeys: [], // 选中的权限的id
            checkedNodes: [], // 全选的节点
            halfCheckedNodes: [], // 半选的节点
            selectedAuth: [],
            judgeAction: '' // 是通过什么操作进入本页面的
        }
    },
    created() {
        if (this.roleMsg.innerid) {
            this._getRoleinfo()
        }
    },
    mounted() {
        let _this = this
        this.$nextTick(() => {
            _this.$refs.powerTree._getRoleView(this.roleMsg.innerid)
        })
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$confirm('请确认您的输入信息是否完整正确？', '提交资料', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            closeOnClickModal: false
                    }).then(() => {
                        let auth = this.$refs.powerTree._getAuth()
                        this._addRole(auth)
                    }).catch(() => {})
                }
            })
        },
        _addRole(auth) {
            this.setLoading(true)
            addRole({
                data: Object.assign({}, this.roleMsg, {authidlist: auth}),
                success: data => {
                    this.setLoading(false)
                    this.$message.success('保存成功')
                    this.$router.push({name: 'SubAccountList', params: {tab: 'roleMag'}})
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        resetForm(formName) {
            this.$router.push({name: 'SubAccountList', params: {tab: 'roleMag'}})
        },
        _getRoleinfo() {
            this.setLoading(true)
            getRoleinfo({
                data: {
                    innerid: this.roleMsg.innerid
                },
                success: data => {
                    this.roleMsg.innerid = data.data.innerid
                    this.roleMsg.rolename = data.data.rolename
                    this.roleMsg.memo = data.data.memo
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        PowerTree
    }
}
</script>
<style lang="scss">
    .roleMsg{
        .basicBox{
            width: 500px;
            .basicTitle{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 20px;
                .erect{
                    color: #409EFF;
                    position: relative;
                    top: -1px;
                }
            }
            .el-form-item__label{
                font-weight: 500;
            }
            .el-textarea__inner{
                width: 400px;
                height: 110px;
                resize: none;
            }
        }
        .rootBox{
            margin-top: 40px;
            .rootTreeBox{
                background: #F5F7FA;
                padding: 20px 0 30px;
                margin-left: 10px;
                .el-tree{
                    background: #F5F7FA;
                    margin-left: 14px;
                }
            }
            .rootTitle{
                font-size: 16px;
                font-weight: 500;
                margin-bottom: 20px;
                .erect{
                    color: #409EFF;
                    position: relative;
                    top: -1px;
                }
            }

        }
        .action{
            margin-top: 40px;
            text-align: center;
            .el-form-item__content{
                margin-left: 0 !important;
            }
        }
    }
</style>
